<template>
    <span>
       {{text}}
    </span>
</template>

<script>
    export default {
        name: "FileCatrgoryText",
        props:{
            value: {
                type: String,
                default:function () {
                    return '' ;
                }
            }
        },
        watch:{

        },
        computed:{
             text(){

                let e =  this.fileCategorys.find((e)=>{
                      return e.code === this.selectValue
                 });

                 return e ? e.name:'';
;
             }
        },
        data(){
            return {
                selectValue:'',
                fileCategorys:[],
            }
        },
        created() {

            let vm = this;
            vm.$http.post(vm.$api.fileCategory.list,vm.$qs.stringify({onPage:false})).then((resp)=>{
                    vm.fileCategorys = resp.data.data.fileCategorys;
                    vm.selectValue = vm.value;

            });

        }
    }
</script>

<style scoped>

</style>